var city = {
  "citycode": "023",
  "adcode": "500000",
  "name": "重庆市",
  "center": {
      "lng": 106.550483,
      "lat": 29.563707
  },
  "districtList": [
      {
          "citycode": "023",
          "adcode": "500200",
          "name": "重庆郊县",
          "center": {
              "lng": 108.170255,
              "lat": 29.291965
          },
          "districtList": [
              {
                  "citycode": "023",
                  "adcode": "500236",
                  "name": "奉节县",
                  "center": {
                      "lng": 109.401056,
                      "lat": 31.018505
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500238",
                  "name": "巫溪县",
                  "center": {
                      "lng": 109.570038,
                      "lat": 31.398619
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500243",
                  "name": "彭水苗族土家族自治县",
                  "center": {
                      "lng": 108.165571,
                      "lat": 29.293748
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500241",
                  "name": "秀山土家族苗族自治县",
                  "center": {
                      "lng": 109.007096,
                      "lat": 28.448248
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500235",
                  "name": "云阳县",
                  "center": {
                      "lng": 108.6975,
                      "lat": 30.930628
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500240",
                  "name": "石柱土家族自治县",
                  "center": {
                      "lng": 108.114251,
                      "lat": 29.999066
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500237",
                  "name": "巫山县",
                  "center": {
                      "lng": 109.878995,
                      "lat": 31.07478
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500230",
                  "name": "丰都县",
                  "center": {
                      "lng": 107.731056,
                      "lat": 29.863785
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500229",
                  "name": "城口县",
                  "center": {
                      "lng": 108.664349,
                      "lat": 31.947319
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500242",
                  "name": "酉阳土家族苗族自治县",
                  "center": {
                      "lng": 108.76726,
                      "lat": 28.841409
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500233",
                  "name": "忠县",
                  "center": {
                      "lng": 108.038073,
                      "lat": 30.299817
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500231",
                  "name": "垫江县",
                  "center": {
                      "lng": 107.332511,
                      "lat": 30.327548
                  }
              }
          ]
      },
      {
          "citycode": "023",
          "adcode": "500100",
          "name": "重庆城区",
          "center": {
              "lng": 106.504962,
              "lat": 29.533155
          },
          "districtList": [
              {
                  "citycode": "023",
                  "adcode": "500117",
                  "name": "合川区",
                  "center": {
                      "lng": 106.27617,
                      "lat": 29.971968
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500152",
                  "name": "潼南区",
                  "center": {
                      "lng": 105.840487,
                      "lat": 30.191077
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500115",
                  "name": "长寿区",
                  "center": {
                      "lng": 107.080945,
                      "lat": 29.857916
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500151",
                  "name": "铜梁区",
                  "center": {
                      "lng": 106.056265,
                      "lat": 29.845248
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500111",
                  "name": "大足区",
                  "center": {
                      "lng": 105.721825,
                      "lat": 29.707555
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500104",
                  "name": "大渡口区",
                  "center": {
                      "lng": 106.482299,
                      "lat": 29.484464
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500107",
                  "name": "九龙坡区",
                  "center": {
                      "lng": 106.510515,
                      "lat": 29.502325
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500114",
                  "name": "黔江区",
                  "center": {
                      "lng": 108.770677,
                      "lat": 29.533609
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500108",
                  "name": "南岸区",
                  "center": {
                      "lng": 106.644254,
                      "lat": 29.50109
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500156",
                  "name": "武隆区",
                  "center": {
                      "lng": 107.759955,
                      "lat": 29.325707
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500110",
                  "name": "綦江区",
                  "center": {
                      "lng": 106.651213,
                      "lat": 29.028117
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500102",
                  "name": "涪陵区",
                  "center": {
                      "lng": 107.246521,
                      "lat": 29.752475
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500109",
                  "name": "北碚区",
                  "center": {
                      "lng": 106.395593,
                      "lat": 29.805197
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500119",
                  "name": "南川区",
                  "center": {
                      "lng": 107.099147,
                      "lat": 29.157879
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500118",
                  "name": "永川区",
                  "center": {
                      "lng": 105.926951,
                      "lat": 29.356384
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500101",
                  "name": "万州区",
                  "center": {
                      "lng": 108.408591,
                      "lat": 30.807621
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500153",
                  "name": "荣昌区",
                  "center": {
                      "lng": 105.6118,
                      "lat": 29.416892
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500112",
                  "name": "渝北区",
                  "center": {
                      "lng": 106.631155,
                      "lat": 29.718087
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500105",
                  "name": "江北区",
                  "center": {
                      "lng": 106.574395,
                      "lat": 29.606224
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500154",
                  "name": "开州区",
                  "center": {
                      "lng": 108.39336,
                      "lat": 31.160416
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500113",
                  "name": "巴南区",
                  "center": {
                      "lng": 106.540603,
                      "lat": 29.402348
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500116",
                  "name": "江津区",
                  "center": {
                      "lng": 106.264435,
                      "lat": 29.319984
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500120",
                  "name": "璧山区",
                  "center": {
                      "lng": 106.204885,
                      "lat": 29.577455
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500106",
                  "name": "沙坪坝区",
                  "center": {
                      "lng": 106.456939,
                      "lat": 29.541017
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500103",
                  "name": "渝中区",
                  "center": {
                      "lng": 106.568955,
                      "lat": 29.552642
                  }
              },
              {
                  "citycode": "023",
                  "adcode": "500155",
                  "name": "梁平区",
                  "center": {
                      "lng": 107.769568,
                      "lat": 30.654233
                  }
              }
          ]
      }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/chongqing.js